import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import en from 'vuetify/lib/locale/en'
import sk from 'vuetify/lib/locale/sk'

export default new Vuetify({
    lang: {
        locales: { en, sk },
        current: process.env.VUE_APP_I18N_LOCALE || 'en',
    }
});
